module.exports = __webpack_public_path__ + "static/media/fleetCompanies.81f99c83.svg";